import moment from 'moment'
import { fetchPendingInvoices } from '../../../PendingInvoices/actions'
import { fetchAccountBalance } from '../../../Account/actions'
import { fetchPaidInvoices } from '../../../PaidInvoices/actions'
import { fetchRecurringCharges } from '../../../RecurringCharges/actions'

export function submitMasterNewChargeForm() {
  return (dispatch, getState) => {
    const state = getState()
    const { transaction_type } = state.masterNewChargeForm

    if (transaction_type == 'single') {
      submitCreateInvoice(dispatch, state)
    } else if (transaction_type == 'recurring') {
      submitCreateRecurringCharge(dispatch, state)
    }
  }
}


function submitCreateInvoice(dispatch, state) {
  const { organization, resident, masterNewChargeForm } = state

  const { amount, memo, did_the_client_already_pay, already_paid_payment_method, group_id,
    has_credit_card_to_charge, payment_source, email, due_date, receipt_email, receipt_note, overdue_invoice_reminder, overdueReminderDays } = masterNewChargeForm

  function getPaymentMethod() {
    if (!!already_paid_payment_method) {
      return already_paid_payment_method
    } else {
      switch (payment_source.kind) {
        case 'card':
        case 'bank_account':
          return 'online'
        default:
          return payment_source.kind
      }
    }
  }

  function getPaymentSource() {
    if (payment_source && (payment_source.kind === 'card' || payment_source.kind === 'bank_account')) {
      return payment_source.id
    } else {
      return undefined
    }
  }

  $.ajax({
    url: `/organizations/${organization.name}/invoices.json`,
    method: 'POST',
    data: {
      invoice: {
        email: email ? email.trim() : '',
        receipt_email: receipt_email ? receipt_email.trim() : '',
        receipt_note: receipt_note,
        issued_at: moment().toISOString(),
        due_date: !(did_the_client_already_pay == 'yes' || has_credit_card_to_charge == 'yes') ? moment(due_date).format('YYYY-MM-DD') : null,
        resident_id: resident.id,
        amount,
        description: memo,
        group_id,
        overdue_invoice_reminder: overdue_invoice_reminder,
        overdue_payment_reminders: overdueReminderDays
      }
    },
    success: (invoice) => {
      dispatch(fetchPendingInvoices())
      if (did_the_client_already_pay == 'yes' || has_credit_card_to_charge == 'yes') {
        $.ajax({
          url: `/organizations/${organization.name}/invoices/${invoice.id}/make_payment.json`,
          method: 'PATCH',
          data: {
            invoice: {
              resident_id: resident.id,
              payment_method: getPaymentMethod(),
              payment_source_id: getPaymentSource(),
            }, charge: {
              description: memo,
            }
          },
          success: () => {
            dispatch(fetchPendingInvoices())
            dispatch(fetchAccountBalance())
            dispatch(fetchPaidInvoices())
            dispatch({ type: 'SUCCESS_SUBMIT_MASTER_CHARGE_FORM' })
          },
          error: xhr => {
            const errors = $.parseJSON(xhr.responseText).errors
            dispatch({ type: 'FAILED_SUBMIT_MASTER_CHARGE_FORM', payload: errors })
          }
        })
      } else {
        dispatch({ type: 'SUCCESS_SUBMIT_MASTER_CHARGE_FORM' })
      }
    },
    error: xhr => {
      const errors = $.parseJSON(xhr.responseText).errors
      dispatch({ type: 'FAILED_SUBMIT_MASTER_CHARGE_FORM', payload: errors })
    }
  })
}


function submitCreateRecurringCharge(dispatch, state) {
  const { resident, organization } = state
  const { memo, amount, interval_count, interval,
    occurrences, ends_at, payment_source, group_id,
    has_credit_card_to_charge, email, receipt_email, receipt_note, first_due_date, first_issue_date, overdue_invoice_reminder, overdueReminderDays } = state.masterNewChargeForm

  function getPaymentMethod() {
    if (has_credit_card_to_charge == 'no') {
      return 'invoice'
    } else if (has_credit_card_to_charge == 'yes') {
      switch (payment_source.kind) {
        case 'card':
        case 'bank_account':
          return 'online'
        default:
          return payment_source.kind
      }
    }
  }

  function getPaymentSource() {
    if (payment_source && (payment_source.kind === 'card' || payment_source.kind === 'bank_account')) {
      return payment_source.id
    } else {
      return undefined
    }
  }


  $.ajax({
    url: `/organizations/${organization.name}/residents/${resident.id}/recurring_charges.json`,
    method: 'POST',
    data: {
      recurring_charge: {
        amount,
        email: email ? email.trim() : '',
        ends_at: ends_at && moment(ends_at).format('YYYY-MM-DD'),
        first_due_date: first_due_date.format('YYYY-MM-DD'),
        first_issue_date: !!first_issue_date ? first_issue_date.format('YYYY-MM-DD') : first_due_date.format('YYYY-MM-DD'),
        group_id,
        interval_count,
        interval,
        name: memo,
        occurrences,
        payment_source_id: getPaymentSource(),
        payment_method: getPaymentMethod(),
        receipt_email: receipt_email ? receipt_email.trim() : '',
        receipt_note: receipt_note,
        starts_at: !!first_issue_date ? first_issue_date.format('YYYY-MM-DD') : first_due_date.format('YYYY-MM-DD'),
        overdue_invoice_reminder: overdue_invoice_reminder,
        overdue_reminder_days: overdueReminderDays
      }
    },
    success: (response) => {
      dispatch(fetchPendingInvoices())
      dispatch(fetchRecurringCharges())
      dispatch({ type: 'SUCCESS_SUBMIT_MASTER_CHARGE_FORM' })
    },
    error: xhr => {
      const errors = $.parseJSON(xhr.responseText).errors
      dispatch({ type: 'FAILED_SUBMIT_MASTER_CHARGE_FORM', payload: errors })
    }
  })
}
